import {
  DEFAULT_REGISTER_RECENCY_STRATUM,
  sanitizeRegisterRecencyStratum,
} from "../constants/registerRecencyStrata";

export const REGISTER_RECENCY_VIEW_MODES = {
  RECENCY: "recency",
  PARUTION: "parution",
};

export const DEFAULT_REGISTER_RECENCY_VIEW_MODE = REGISTER_RECENCY_VIEW_MODES.RECENCY;

export const REGISTER_RECENCY_STRATUM_STORAGE_KEY =
  "vocabularium_register_recency_stratum";
export const REGISTER_RECENCY_SCROLL_STORAGE_KEY =
  "vocabularium_register_recency_scroll";
export const REGISTER_RECENCY_VIEW_MODE_STORAGE_KEY =
  "vocabularium_register_recency_view_mode";
export const REGISTER_RECENCY_GRADATION_SORT_STORAGE_KEY =
  "vocabularium_register_recency_gradation_sort";

export const REGISTER_GRADATION_SORT_MODES = {
  REVIEW_FIRST: "reviewFirst",
  MASTERED_FIRST: "masteredFirst",
};

export const DEFAULT_REGISTER_GRADATION_SORT =
  REGISTER_GRADATION_SORT_MODES.REVIEW_FIRST;

export const REGISTER_GRADATION_SORT_OPTIONS = [
  { value: REGISTER_GRADATION_SORT_MODES.REVIEW_FIRST, label: "Mots à revoir en premier" },
  { value: REGISTER_GRADATION_SORT_MODES.MASTERED_FIRST, label: "Mots maîtrisés en premier" },
];

export function sanitizeRegisterGradationSort(value) {
  return value === REGISTER_GRADATION_SORT_MODES.MASTERED_FIRST
    ? REGISTER_GRADATION_SORT_MODES.MASTERED_FIRST
    : REGISTER_GRADATION_SORT_MODES.REVIEW_FIRST;
}

export function readRegisterRecencyGradationSort() {
  try {
    return sanitizeRegisterGradationSort(
      localStorage.getItem(REGISTER_RECENCY_GRADATION_SORT_STORAGE_KEY)
    );
  } catch {
    return DEFAULT_REGISTER_GRADATION_SORT;
  }
}

export function writeRegisterRecencyGradationSort(mode) {
  const next = sanitizeRegisterGradationSort(mode);
  try {
    localStorage.setItem(REGISTER_RECENCY_GRADATION_SORT_STORAGE_KEY, next);
  } catch {
    // quota / mode privé : on ignore
  }
  return next;
}

export function sanitizeRegisterRecencyViewMode(value) {
  return value === REGISTER_RECENCY_VIEW_MODES.PARUTION
    ? REGISTER_RECENCY_VIEW_MODES.PARUTION
    : REGISTER_RECENCY_VIEW_MODES.RECENCY;
}

export function readRegisterRecencyViewMode() {
  try {
    return sanitizeRegisterRecencyViewMode(
      localStorage.getItem(REGISTER_RECENCY_VIEW_MODE_STORAGE_KEY)
    );
  } catch {
    return DEFAULT_REGISTER_RECENCY_VIEW_MODE;
  }
}

export function writeRegisterRecencyViewMode(mode) {
  const next = sanitizeRegisterRecencyViewMode(mode);
  try {
    localStorage.setItem(REGISTER_RECENCY_VIEW_MODE_STORAGE_KEY, next);
  } catch {
    // quota / mode privé : on ignore
  }
  return next;
}

export function readRegisterRecencyStratum() {
  try {
    return sanitizeRegisterRecencyStratum(
      localStorage.getItem(REGISTER_RECENCY_STRATUM_STORAGE_KEY)
    );
  } catch {
    return DEFAULT_REGISTER_RECENCY_STRATUM;
  }
}

export function writeRegisterRecencyStratum(stratumId) {
  const next = sanitizeRegisterRecencyStratum(stratumId);
  try {
    localStorage.setItem(REGISTER_RECENCY_STRATUM_STORAGE_KEY, next);
  } catch {
    // quota / mode privé : on ignore
  }
  return next;
}

export function readRegisterRecencyScrollMap() {
  try {
    const raw = localStorage.getItem(REGISTER_RECENCY_SCROLL_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function writeRegisterRecencyScrollMap(map) {
  try {
    localStorage.setItem(
      REGISTER_RECENCY_SCROLL_STORAGE_KEY,
      JSON.stringify(map && typeof map === "object" ? map : {})
    );
  } catch {
    // quota / mode privé : on ignore
  }
}
